<h2 mat-dialog-title>View File</h2>

<mat-dialog-content>

  <!-- PDF -->
  <iframe *ngIf="data.type === 'pdf'"
          [src]="sanitizedUrl"
          width="100%"
          height="500px">
  </iframe>

  <!--<div *ngIf="fileUrl && data.type === 'pdf'" style="width: 100%; height: 100%;">
    <iframe [src]="sanitizedUrl" style="width: 100%; height: 100%; border: none;"></iframe>
  </div>-->
  <!-- Image -->
  <img *ngIf="data.type === 'image'"
       [src]="sanitizedUrl"
       width="100%" />

  <!-- Video -->
  <video *ngIf="data.type === 'video'"
         width="100%"
         controls>
    <source [src]="sanitizedUrl" />
  </video>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
